import { resourceQueryParamName } from 'constants/resourceQueryNames';
import useInvestigations from 'hooks/investigations/useInvestigations';
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';
import { getNavParamsByResource } from 'selectors/nav';

const InvestigationsListCount: React.FC = () => {
  const { data, isLoading } = useInvestigations();

  const navParams = useSelector(getNavParamsByResource(resourceQueryParamName.investigations));
  const offset = parseInt(navParams.offset as string, 10);

  if (!data) return null;

  return (
    <div>
      <div className={`${isLoading ? 'text-litlingo-gray-2' : ''}`}>
        <span className="font-bold">{` ${data.records.length === 0 ? 0 : offset + 1}-${
          offset + data.records.length
        }`}</span>
        {` of ${
          data && data.count >= 10000
            ? '+10,000'
            : pluralize('investigation'.split(' ').map(capitalize).join(' '), data.count, true)
        }`}
      </div>
    </div>
  );
};

export default InvestigationsListCount;
